export default {
  title: 'ROAS by Channel',
  xAxisName: 'Channel',
  mean: 'Mean',
  lower: 'Lower',
  upper: 'Upper',
  crossUnitWarning: 'Each bar is the {kpi} the model attributes to the channel divided by what was spent on it, and the two are measured in different units. That is why the y axis is not in "times the money back" but in {unit}: the {kpi} that each unit of spend brought in. The channels are still comparable with each other and the confidence range still holds — what does not apply is comparing them against the ROAS of a model whose {kpi} and spend share a unit.',
  dataView: 'Data View',
  close: 'Close',
  refresh: 'Refresh',
  saveAsImage: 'Save as Image'
}
